var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Home_Icon",
    "data-name": "Home Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.979,
    height: 14.925,
    viewBox: "0 0 15.979 14.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Home_Icon-2",
    "data-name": "Home Icon",
    d: "M-1446.007-954.074h-3.424v-7.04H-1452l7.99-7.885,7.99,7.885h-2.568v7.04h-3.139v-4.787h-4.28v4.787Z",
    transform: "translate(1452 968.999)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home Icon.2029fbfd48fc54047e68bcc3be32ad6c.svg";
export { ForwardRef as ReactComponent };